import { useEffect } from 'react'

// Adds `is-visible` to every `.mv-reveal` element inside the page once it scrolls into view,
// so sections can fade up. Without IntersectionObserver (or with reduced motion via CSS) they simply show.
const useReveal = (deps = []) => {
    useEffect(() => {
        const nodes = Array.from(document.querySelectorAll('.mv-reveal:not(.is-visible)'))
        if (!('IntersectionObserver' in window)) {
            nodes.forEach(n => n.classList.add('is-visible'))
            return undefined
        }
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible')
                    observer.unobserve(entry.target)
                }
            })
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 })
        nodes.forEach(n => observer.observe(n))
        return () => observer.disconnect()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps)
}

export default useReveal
